import {sidebarColor} from "../../assets/jss/main";
import PropTypes from "prop-types";

NumberCircle.propsTypes = {
    number: PropTypes.number.isRequired,
}

/**
 * This is a simple component that displays a number in a circle. It takes a number as a prop
 * @returns {JSX.Element}
 */
export default function NumberCircle({number}) {
    const minCircleSize = '18px';
    return (
        <div style={{
            textAlign: 'center',
            backgroundColor: sidebarColor,
            minWidth: minCircleSize,
            minHeight: minCircleSize,
            padding: '1px',
            position: 'absolute',
            top: '-17%',
            right: '-17%',
            border: '1px solid',
            borderRadius: '20px',
            fontSize: '10px'
        }}>
            {number}
        </div>
    )
}